import { MODAL_NAMES } from '@/consts';

import { SET_ACTIVE_MODAL } from './types';

const actions = {
  toggleSessionExpiredModal({ commit }, val) {
    const stacking = false;
    commit(SET_ACTIVE_MODAL, { name: MODAL_NAMES.SESSION_EXPIRED, val, stacking });
  },

  togglePaymentReminderClientDetailsModal({ commit }, val) {
    const stacking = false;
    commit(SET_ACTIVE_MODAL, { name: MODAL_NAMES.PAYMENT_REMINDER_CLIENT_DETAILS, val, stacking });
  },

  toggleConfirmModal({ commit }, val) {
    const stacking = true;
    commit(SET_ACTIVE_MODAL, { name: MODAL_NAMES.CONFIRM, val, stacking });
  },

  toggleEditOrderModal({ commit }, val) {
    const stacking = true;
    commit(SET_ACTIVE_MODAL, { name: MODAL_NAMES.EDIT_ORDER, val, stacking });
  },

  toggleEditClientModal({ commit }, val) {
    const stacking = true;
    commit(SET_ACTIVE_MODAL, { name: MODAL_NAMES.EDIT_CLIENT, val, stacking });
  },

  toggleOrderNoteModal({ commit }, val) {
    const stacking = false;
    commit(SET_ACTIVE_MODAL, { name: MODAL_NAMES.ORDER_NOTE, val, stacking });
  },

  toggleEditAssetModal({ commit }, val) {
    const stacking = true;
    commit(SET_ACTIVE_MODAL, { name: MODAL_NAMES.EDIT_ASSET, val, stacking });
  }

};

export default actions;
